import { ComponentPortal } from '@angular/cdk/portal';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNil } from 'lodash';
import { ReplaySubject, takeUntil } from 'rxjs';

import { SharedCropperComponent } from 'app/shared/cropper/cropper-component';
import { ModalService } from 'app/shared/modals/modal.service';
import { Loggable } from 'app/utils/logging/loggable';
import ImageController from 'rest/ImageController';

@Component({
  selector: 'app-modal-registrant-profile-picture',
  templateUrl: './modal-registrant-profile-picture.component.html',
  styleUrl: './modal-registrant-profile-picture.component.scss',
  standalone: false,
})
export class ModalRegistrantProfilePictureComponent extends Loggable implements OnInit, OnDestroy {
  public profileImage = '';
  public profileImageId?: string;
  protected isDoneDisabled = false;
  private destroyed$ = new ReplaySubject<boolean>(1);
  private imageController = new ImageController();

  public constructor(
    private dialogRef: MatDialogRef<ModalRegistrantProfilePictureComponent>,
    private modalService: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: { currentImage?: string; currentImageId?: string },
  ) {
    super();
  }

  public ngOnInit(): void {
    if (this.data.currentImage) {
      this.profileImage = this.data.currentImage;
      this.profileImageId = this.data.currentImageId;
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public onFileChanged(event: unknown): void {
    this.openCropper(event);
  }

  private openCropper(data: unknown): void {
    const ref = new ComponentPortal(SharedCropperComponent, null, this.modalService.createInjector({ data }));
    this.modalService
      .open({ title: 'Image Cropper' }, ref)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result) => {
        this.isDoneDisabled = true;
        if (result) {
          this.blobToBase64(result.blob, (base64) => {
            this.imageController
              .uploadSafeBase64Image(
                'web-profile-image',
                result.blob.type,
                result.width,
                result.height,
                base64.split(',')[1],
              )
              .then((res) => {
                this.profileImageId = res.imageId;
                this.isDoneDisabled = false;
              })
              .catch((err) => this.error(err));
            this.profileImage = base64;
          });
        }
      });
  }

  public deleteImage(): void {
    this.profileImage = '';
    this.profileImageId = undefined;
  }

  public closeModal(): void {
    this.dialogRef.close({ imageId: this.profileImageId, base64: this.profileImage });
  }

  private blobToBase64(blob: Blob, callback: (base64String: string) => void): void {
    const reader = new FileReader();
    reader.onloadend = function () {
      if (typeof reader.result === 'string') {
        callback(reader.result);
      } else {
        throw new Error('Invalid result type. Expected string.');
      }
    };
    reader.readAsDataURL(blob);
  }

  public isDisabled(): boolean {
    return isNil(this.profileImage);
  }
}
